import { render, staticRenderFns } from "./TabList.vue?vue&type=template&id=25ce9a02"
import script from "./TabList.vue?vue&type=script&lang=js"
export * from "./TabList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports